import { render, staticRenderFns } from "./pageEditor.vue?vue&type=template&id=89b80254&"
import script from "./pageEditor.vue?vue&type=script&lang=js&"
export * from "./pageEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports